import React from 'react';
import { MenuItem, NavDropdown } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useSignalRListener } from '../../signalR/useSignalRListener';
import { IconSVG, View } from '../Icons/Icons';
import { generateLink } from '../Utils/Commons';

const TestNotifications = (props) => {
    const { t } = useTranslation()
    const dispatch = useDispatch();

    useSignalRListener('TestNotification', res => {
        dispatch({
            type: 'NOTIFICATION_RECEIVED',
            payload: {
                ...res
            }
        });
    });

    var notifications = <MenuItem eventKey={`3.1`}>{t("notifications.noNotifications")}</MenuItem>;
    var notifCountContainer = null;

    if (props.notifications && props.notifications.length > 0) {
        let unreaded = 0;
        notifications = props.notifications?.map((notification, index) => {
            if (notification.status === 0) {
                unreaded++;
                return (
                    <li role="presentation" key={`3.${index}`}>
                        <NavLink to={generateLink(notification.params)} activeClassName="active" role="menuitem" >
                            {notification.content}  <View style={{ fontSize: '20px' }} />
                        </NavLink>
                    </li>
                )
            }

            return null;
        });

        if (unreaded > 0)
            notifCountContainer = <span className="notification">{unreaded}</span>;
    }

    const title = (
        <>
            <IconSVG name="notification" fill="#c5c5c5" />
            {notifCountContainer}
            <p className="hidden-md hidden-lg">
                {t("notifications.notifications")}
                <b className="caret" />
            </p>
        </>
    );

    return (
        <NavDropdown
            eventKey={"3"}
            title={title}
            noCaret
            id="notifications-dropdown"
            bsClass="notifications-dropdown dropdown"
        >
            {notifications}
        </NavDropdown>
    )
}

const AdminNavbarNotificationsContainer = connect(state => state.notifications)(TestNotifications);

export default AdminNavbarNotificationsContainer;